let thumbSwiper;
let mainSwiper;

function initSwipers() {
  // Asegurarse de que los elementos existen antes de destruir las instancias anteriores de Swiper
  const contentCorner = document.querySelector('.content-image-corner');
  const contentRibbon = document.querySelector('.content-image-ribbon');

  if (thumbSwiper) thumbSwiper.destroy(true, true);
  if (mainSwiper) mainSwiper.destroy(true, true);

  const thumbSwiperEl = document.querySelector('.thumb-swiper');
  const mainSwiperEl = document.querySelector('.swiper-main-media');

  // Verificar que los elementos del Swiper están disponibles antes de continuar
  if (!thumbSwiperEl || !mainSwiperEl) {
    console.error('Swiper elements not found');
    return; // Detener ejecución si no se encuentran los elementos
  }

  thumbSwiper = new Swiper(thumbSwiperEl, {
    spaceBetween: 4,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      768: { slidesPerView: 4 },
      1024: { slidesPerView: 3.8 }
    }
  });

  mainSwiper = new Swiper(mainSwiperEl, {
    spaceBetween: 10,
    navigation: {
      nextEl: '.swiper-button-next-pdp',
      prevEl: '.swiper-button-prev-pdp',
    },
    thumbs: {
      swiper: thumbSwiper,
    },
    pagination: {
      el: '.swiper-pagination', // Selecciona el contenedor donde se generarán los dots
      clickable: true,           // Habilita la opción de que se pueda hacer clic en los dots para navegar
    },
    on: {
      slideChange: () => {
        const currentIndex = mainSwiper.activeIndex;

        const thumbsContainer = thumbSwiper.el.querySelector('.swiper-wrapper');
        // Verificar que las slides existan antes de intentar acceder a sus propiedades
        if (thumbSwiper.slides.length > 0) {
          const slideWidth = thumbSwiper.slides[0].offsetWidth + thumbSwiper.params.spaceBetween;
          const swiperWidth = thumbSwiper.width;

          const centerOffset = (swiperWidth / 2) - (slideWidth / 2);
          const scrollPosition = (slideWidth * currentIndex) - centerOffset;

          // Limitar para que no se pase del último slide
          const maxTranslate = thumbsContainer.scrollWidth - swiperWidth;
          const finalTranslate = Math.max(0, Math.min(scrollPosition, maxTranslate));

          thumbSwiper.setTransition(300);
          thumbSwiper.setTranslate(-finalTranslate);
        }

        const isFirstSlide = currentIndex === 0;

        if (contentCorner && contentRibbon) {
          contentCorner.style.display = isFirstSlide ? 'block' : 'none';
          contentRibbon.style.display = isFirstSlide ? 'block' : 'none';
        }
      }
    }
  });

  const isFirstSlide = mainSwiper.activeIndex === 0;

  if (contentCorner && contentRibbon) {
    contentCorner.style.display = isFirstSlide ? 'block' : 'none';
    contentRibbon.style.display = isFirstSlide ? 'block' : 'none';
  }

  // Reasignar clics
  document.querySelectorAll('.product__media-thumbnail').forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      mainSwiper.slideTo(index);
      const visibleSlides = thumbSwiper.params.slidesPerView;
      const targetIndex = Math.max(index - Math.floor(visibleSlides / 2), 0);
      thumbSwiper.slideTo(targetIndex);
    });
  });

  const zoomResult = document.getElementById("zoom-result");

  // Aplica el efecto a todas las imágenes dentro de slides activos
  document.querySelectorAll(".swiper-main-media img").forEach((img) => {
    img.addEventListener("mouseenter", () => {
      zoomResult.style.display = "block";
      zoomResult.style.backgroundImage = `url('${img.src}')`;
    });

    img.addEventListener("mouseleave", () => {
      zoomResult.style.display = "none";
    });

    img.addEventListener("mousemove", (e) => {
      const rect = img.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const xPercent = (x / img.offsetWidth) * 100;
      const yPercent = (y / img.offsetHeight) * 100;

      zoomResult.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
    });
  });

  const image = document.querySelector('.zoom-image');
  const lens = document.querySelector('.zoom-lens');
  const result = document.querySelector('.zoom-result');

  if (image && lens && result) {
    const zoom = 3;
    result.style.backgroundImage = `url('${image.src}')`;
    result.style.backgroundSize = `${image.width * zoom}px ${image.height * zoom}px`;

    image.addEventListener('mousemove', moveLens);
    lens.addEventListener('mousemove', moveLens);
    image.addEventListener('mouseleave', () => {
      lens.style.display = 'none';
      result.style.display = 'none';
    });
    image.addEventListener('mouseenter', () => {
      lens.style.display = 'block';
      result.style.display = 'block';
    });

    function moveLens(e) {
      const rect = image.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;

      x = x - lens.offsetWidth / 2;
      y = y - lens.offsetHeight / 2;

      if (x > image.width - lens.offsetWidth) x = image.width - lens.offsetWidth;
      if (x < 0) x = 0;
      if (y > image.height - lens.offsetHeight) y = image.height - lens.offsetHeight;
      if (y < 0) y = 0;

      lens.style.left = x + 'px';
      lens.style.top = y + 'px';

      result.style.backgroundPosition = `-${x * zoom}px -${y * zoom}px`;
    }
  }
}

document.addEventListener('DOMContentLoaded', initSwipers);
